import { GridViewWebComponent } from './component/GridViewWebComponent';
import { WEB_COMPONENT_GRID_VIEW } from '../../webcomponents.constants';

export { GridViewWebComponent };

window.customElements.define(WEB_COMPONENT_GRID_VIEW, GridViewWebComponent);
